"use client";

import { useCallback, useState } from "react";

export const useBoolean = (defaultValue = false) => {
  const [value, setValue] = useState(defaultValue);

  const on = useCallback(() => {
    setValue(true);
  }, []);

  const off = useCallback(() => {
    setValue(false);
  }, []);

  const toggle = useCallback(() => {
    setValue((prev) => !prev);
  }, []);

  return { value, on, off, toggle } as const;
};
